// Interactions and Depletions iframe loading events
$(document).ready(function () {
  $("#interactions-depletions #accordion .accordion-button").click(function () {
    var interactionContainer = $(this)
      .parent()
      .next()
      .find(".interaction-container");

    if ($.trim(interactionContainer.html()).length == 0) {
      // TODO: need to get a loading spinner to show/remove
      var loadingSpinner =
        '<div id="interaction-loader" style="float: left;width: 100%;text-align: center;padding: 2%;">' +
        '<img src="spinner.gif" alt="Loading..." id="interaction-spinner">' +
        "</div>";
      $(this).prepend(loadingSpinner);

      var ingredientKey = $(this).attr('dniIngredientKey');
      console.log('ingredientKey for checker = ' + ingredientKey); 
      getInteractionsHtml(ingredientKey, interactionContainer);
    }
  });
});

function getInteractionsHtml(ingredient, interactionContainer) {
  try {
    $.ajax({
      type: "POST",
      // TODO: configure the url?
      url: dniUrl + ingredient + "&test=1",
      success: function success(result) {
        bindInteractionsHtml(result, interactionContainer);
      },
      error: function error(_error) {
        $("#interaction-loader").remove();
        console.log(_error);
      },
    });
  } catch (err) {
    $("#interaction-loader").remove();
  }
}

function bindInteractionsHtml(html, interactionContainer) {
  try {
    $(interactionContainer).html(html);
    $(interactionContainer).ready(function () {
      $("#interaction-loader").remove();
      $(
        "header.hni_header.hni_header--page, header.hni_header.hni_header--article"
      ).remove();
      $(".hni_data-list-item--supportive").click(function () {
        showHideAccordion($(this), ".hni_data-list-item--supportive");
      });
      $(".hni_data-list-item--caution").click(function () {
        showHideAccordion($(this), ".hni_data-list-item--caution");
      });
      $(".hni_data-list-item--interaction").click(function () {
        showHideAccordion($(this), ".hni_data-list-item--interaction");
      });
      $("button.hni_btn--references").click(function () {
        $(this)
          .parent("section.hni_interaction__content")
          .next("section.hni_modal--references")
          .removeClass("hni_hidden")
          .addClass("hni_visible")
          .css("top", "15%");
        $("#wrapper").addClass("hni_ContentPanel hni_modal__mask");
        return false;
      });
      $(
        "section.hni_modal.hni_modal--references .hni_icon-made-from-text--closer"
      ).click(function (event) {
        $(this)
          .parent()
          .parent()
          .removeClass("hni_visible")
          .addClass("hni_hidden");
        $("#wrapper").removeClass("hni_ContentPanel hni_modal__mask");
        event.preventDefault();
        return false;
      });
      $(
        "li.hni_data-list-item.hni_hic__supportive, section.hni_modal.hni_modal--references, section.hni_interaction__content"
      ).click(function () {
        return false;
      });
      $("footer.hni_footer--references").click(function () {
        if (
          !$(this)
            .find("section.hni_data-list-item")
            .hasClass("hni_data-list-item--open")
        ) {
          $(
            "footer.hni_footer--references section.hni_data-list-item"
          ).addClass("hni_data-list-item--open");
          $(
            "footer.hni_footer--references header.hni_data-list__header button.hni_icon-made-from-text--collapser"
          )
            .addClass("hni_visible")
            .removeClass("hni_hidden");
          $(
            "footer.hni_footer--references header.hni_data-list__header button.hni_icon-made-from-text--expander"
          )
            .addClass("hni_hidden")
            .removeClass("hni_visible");
          $("footer.hni_footer--references section.hni_data-list-item__content")
            .addClass("hni_visible")
            .removeClass("hni_hidden");
        } else {
          $(
            "footer.hni_footer--references section.hni_data-list-item"
          ).removeClass("hni_data-list-item--open");
          $(
            "footer.hni_footer--references header.hni_data-list__header button.hni_icon-made-from-text--collapser"
          )
            .addClass("hni_hidden")
            .removeClass("hni_visible");
          $(
            "footer.hni_footer--references header.hni_data-list__header button.hni_icon-made-from-text--expander"
          )
            .addClass("hni_visible")
            .removeClass("hni_hidden");
          $("footer.hni_footer--references section.hni_data-list-item__content")
            .addClass("hni_hidden")
            .removeClass("hni_visible");
        }
        return false;
      });
      $(
        "footer.hni_footer--references section.hni_data-list-item__content"
      ).click(function () {
        return false;
      });
    });
  } catch (err) {}
}

function showHideAccordion(selector, selectorClass) {
  if (
    selector
      .children("section.hni_interaction__content")
      .hasClass("hni_visible")
  ) {
    selector
      .children("section.hni_interaction__content")
      .removeClass("hni_visible")
      .addClass("hni_hidden");
    selector
      .children("header")
      .children("button.hni_icon-made-from-text--expander")
      .removeClass("hni_hidden")
      .addClass("hni_visible");
    selector
      .children("header")
      .children("button.hni_icon-made-from-text--collapser")
      .removeClass("hni_visible")
      .addClass("hni_hidden");
  } else {
    $(selectorClass)
      .children("section.hni_interaction__content")
      .removeClass("hni_visible")
      .addClass("hni_hidden");
    $(selectorClass)
      .children("header")
      .children("button.hni_icon-made-from-text--expander")
      .removeClass("hni_hidden")
      .addClass("hni_visible");
    $(selectorClass)
      .children("header")
      .children("button.hni_icon-made-from-text--collapser")
      .removeClass("hni_visible")
      .addClass("hni_hidden");
    selector
      .children("section.hni_interaction__content")
      .removeClass("hni_hidden")
      .addClass("hni_visible");
    selector
      .children("header")
      .children("button.hni_icon-made-from-text--collapser")
      .removeClass("hni_hidden")
      .addClass("hni_visible");
    selector
      .children("header")
      .children("button.hni_icon-made-from-text--expander")
      .removeClass("hni_visible")
      .addClass("hni_hidden");
  }
}